import { render, staticRenderFns } from "./beef.vue?vue&type=template&id=6e9f3c4a&scoped=true&"
import script from "./beef.vue?vue&type=script&lang=js&"
export * from "./beef.vue?vue&type=script&lang=js&"
import style0 from "./beef.vue?vue&type=style&index=0&id=6e9f3c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9f3c4a",
  null
  
)

export default component.exports